export default __webpack_public_path__ + "static/media/dollar-icon.f8f701b3.svg";